import dayjs from 'dayjs'
import { t } from 'i18next'
import { Card } from 'primereact/card'
import React from 'react'
import { Apprentice, Person } from '../../../model/person.model'
import { useAppSelector } from '../../../redux/hooks'
import { compareIfMonthAndDayAreEqual } from '../../../util/math'

export const BirthdayBox = (): JSX.Element => {
  let apprenticesWithBirthday: Person[] = []
  let employeesWithBirthday: Person[] = []

  const apprentices: Apprentice[] = useAppSelector(
    (state) => state.apprentices
  )

  const employees: Person[] = useAppSelector((state) => state.employees)

  const getAllWithBirthday = (people: Person[]) => {
    const birthdayKids: Person[] = []
    const today = dayjs()
    people.forEach((person) => {
      if (person?.birthdate && person.is_active === 1) {
        const hastBirthday = compareIfMonthAndDayAreEqual(
          today.toDate(),
          dayjs(person.birthdate).toDate()
        )
        if (hastBirthday) {
          birthdayKids.push(person)
        }
      }
    })

    return birthdayKids
  }

  function getAgeInYears(
    birthdate: Date | undefined | null
  ): number | undefined {
    if (birthdate === undefined || birthdate === null) {
      return undefined
    }
    return dayjs().diff(dayjs(birthdate), 'year')
  }

  const getApprenticeBirthdayList = () => {
    if (apprenticesWithBirthday.length === 0) {
      return ''
    }

    // we did not return, so someone of the apprentices celebrates birthday
    return (
      <>
        <ol>
          {apprenticesWithBirthday.map((kid, key) => {
            return (
              <li key={key}>
                {kid.full_name}: {getAgeInYears(kid.birthdate)}
              </li>
            )
          })}
        </ol>
      </>
    )
  }

  const getEmployeeBirthdayList = () => {
    if (employeesWithBirthday.length === 0) {
      return ''
    }
    // we did not return, so someone of the employees celebrates birthday

    return (
      <>
        <ul>
          {employeesWithBirthday.map((kid, key) => {
            return <li key={key}>{kid.full_name}</li>
          })}
        </ul>
      </>
    )
  }

  const getContent = () => {
    employeesWithBirthday = getAllWithBirthday(employees)
    apprenticesWithBirthday = getAllWithBirthday(apprentices)

    if (
      employeesWithBirthday.length === 0 &&
      apprenticesWithBirthday.length === 0
    ) {
      return null
    }

    return (
      <Card
        className={'bday-box business-card business-card-width bday-background'}
      >
        <span
          className={'card-role pb-1 flex justify-content-end'}
          style={{ borderBottom: '2px solid #fff', width: '90%' }}
        >
          {t<string>('birthday.current_birthdays')}
        </span>
        <div
          className={'col-12 pl-2 mt-4'}
          style={{
            display: 'block',
            maxHeight: '154px',
            height: '154px',
            overflow: 'auto',
          }}
        >
          <div className={''}>{getApprenticeBirthdayList()}</div>
          <div className={''}>{getEmployeeBirthdayList()}</div>
        </div>
      </Card>
    )
  }

  return <>{getContent()}</>
}